var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoTableCouchB = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 105 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M84 1h19.5v12.5A2.5 2.5 0 0 1 101 16H86.5a2.5 2.5 0 0 1-2.5-2.5V1ZM63.5 1H83v12.5a2.5 2.5 0 0 1-2.5 2.5H66a2.5 2.5 0 0 1-2.5-2.5V1ZM43 1h19.5v12.5A2.5 2.5 0 0 1 60 16H45.5a2.5 2.5 0 0 1-2.5-2.5V1ZM22.5 1H42v12.5a2.5 2.5 0 0 1-2.5 2.5H25a2.5 2.5 0 0 1-2.5-2.5V1ZM2 1h19.5v12.5A2.5 2.5 0 0 1 19 16H4.5A2.5 2.5 0 0 1 2 13.5V1Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M103.5 11V3.5A2.5 2.5 0 0 0 101 1H4.144a2.5 2.5 0 0 0-2.5 2.5V11"
})));
SvgNoTableCouchB.viewBox = '0 0 105 16';
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoTableCouchB);
export default ForwardRef;